import React from 'react';
import {useHistory} from 'react-router';
import {Translate, useTranslation} from '../../config/TranslationProvider';
import Title from './layout/Title';

const PageNotFound = () => {

    const title = useTranslation('Page not found');

    const history = useHistory();
    const handleToHomepageButton = () => {
        history.push('/');
    };
    return (
        <div className="pageNotFound">
            <Title>{title}</Title>
            <div>
                <h1 style={{textAlign: 'center'}}><Translate value="page_not_found_headline" /></h1>
                <button className="btn btn-gradient btn-gradient-two btn-md btn_search" onClick={history.goBack}>
                    <Translate value="back" />
                </button>
                <button className="btn btn-gradient btn-gradient-two btn-md btn_search" onClick={handleToHomepageButton}>
                    <Translate value="homepage" />
                </button>
            </div>
        </div>
    );
};

export default PageNotFound;
